(function () {
  if (window.__freteFrenetProdutoLoaded) return;
  window.__freteFrenetProdutoLoaded = true;

  async function getCart() {
    const response = await fetch('/cart.js');
    return await response.json();
  }

  async function addTempVariant(variantId, quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: quantity || 1 })
    });

    if (!response.ok) throw new Error('Erro ao adicionar produto temporário.');
    return await response.json();
  }

  async function changeVariantQuantity(variantId, quantity) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(variantId), quantity: quantity })
    });
  }

  async function prepareShippingRates(zip, province) {
    const params = new URLSearchParams();

    params.append('shipping_address[zip]', zip);
    params.append('shipping_address[country]', 'Brazil');
    params.append('shipping_address[province]', province || '');

    await fetch('/cart/prepare_shipping_rates', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString()
    });
  }

  async function getAsyncShippingRates() {
    for (let i = 0; i < 12; i++) {
      const response = await fetch('/cart/async_shipping_rates');

      if (response.status === 200) {
        const data = await response.json();
        return data.shipping_rates || [];
      }

      await new Promise(resolve => setTimeout(resolve, 250));
    }

    return [];
  }

  async function getAddressByCep(cep) {
    const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
    const data = await response.json();

    if (data.erro) throw new Error('CEP não encontrado.');

    const states = {
      AC: 'Acre',
      AL: 'Alagoas',
      AP: 'Amapá',
      AM: 'Amazonas',
      BA: 'Bahia',
      CE: 'Ceará',
      DF: 'Distrito Federal',
      ES: 'Espírito Santo',
      GO: 'Goiás',
      MA: 'Maranhão',
      MT: 'Mato Grosso',
      MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais',
      PA: 'Pará',
      PB: 'Paraíba',
      PR: 'Paraná',
      PE: 'Pernambuco',
      PI: 'Piauí',
      RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte',
      RS: 'Rio Grande do Sul',
      RO: 'Rondônia',
      RR: 'Roraima',
      SC: 'Santa Catarina',
      SP: 'São Paulo',
      SE: 'Sergipe',
      TO: 'Tocantins'
    };

    return states[data.uf] || '';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.freteFrenetMoneyFormat || 'R$ {{amount_with_comma_separator}}');
    }

    return (Number(cents) / 100).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  }

  function getSelectedVariantId(box) {
    const productForm = box.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const variantInput = productForm ? productForm.querySelector('[name="id"]') : null;

    if (variantInput && variantInput.value) return variantInput.value;

    return box.dataset.variantId;
  }

  function getQuantity(box) {
    const productForm = box.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const quantityInput = productForm ? productForm.querySelector('[name="quantity"]') : null;

    return quantityInput ? Number(quantityInput.value || 1) : 1;
  }

  function renderRates(resultBox, rates) {
    if (!rates || !rates.length) {
      resultBox.innerHTML = '<p class="frete-frenet-error">Nenhuma opção de frete encontrada para este CEP.</p>';
      return;
    }

    resultBox.innerHTML = `
      <div class="frete-frenet-rates">
        ${rates.map(rate => {
          const price = Number(rate.price) === 0 ? 'Grátis' : formatMoney(rate.price);
          const days = rate.delivery_days && rate.delivery_days.length
            ? `Entrega em até ${rate.delivery_days[0]} dias úteis`
            : 'Prazo informado no checkout';

          return `
            <div class="frete-frenet-rate">
              <div>
                <strong>${rate.name}</strong>
                <span>${days}</span>
              </div>
              <strong>${price}</strong>
            </div>
          `;
        }).join('')}
      </div>
    `;
  }

  async function calculateShipping(box) {
    const input = box.querySelector('.frete-frenet-cep');
    const button = box.querySelector('.frete-frenet-button');
    const result = box.querySelector('.frete-frenet-result');

    const cep = input.value.replace(/\D/g, '');
    const variantId = getSelectedVariantId(box);
    const quantity = getQuantity(box);

    if (cep.length !== 8) {
      result.innerHTML = '<p class="frete-frenet-error">Digite um CEP válido.</p>';
      return;
    }

    if (!variantId) {
      result.innerHTML = '<p class="frete-frenet-error">Não foi possível identificar a variação do produto.</p>';
      return;
    }

    button.disabled = true;
    button.textContent = 'Calculando...';
    result.innerHTML = '<p>Calculando frete...</p>';

    let originalQuantity = 0;

    try {
      const province = await getAddressByCep(cep);
      const cartBefore = await getCart();

      const existingItem = cartBefore.items.find(item => String(item.variant_id) === String(variantId));
      originalQuantity = existingItem ? existingItem.quantity : 0;

      await addTempVariant(variantId, quantity);

      await prepareShippingRates(cep, province);
    const rates = await getAsyncShippingRates();

    renderRates(result, rates);

    changeVariantQuantity(variantId, originalQuantity).catch(console.error);
    } catch (error) {
      console.error(error);

      try {
        await changeVariantQuantity(variantId, originalQuantity);
      } catch (restoreError) {
        console.error(restoreError);
      }

      result.innerHTML = '<p class="frete-frenet-error">Erro ao calcular o frete. Tente novamente.</p>';
    } finally {
      button.disabled = false;
      button.textContent = 'Calcular';
    }
  }

  document.addEventListener('input', function (event) {
    if (!event.target.classList.contains('frete-frenet-cep')) return;

    let value = event.target.value.replace(/\D/g, '');

    if (value.length > 5) {
      value = value.replace(/^(\d{5})(\d)/, '$1-$2');
    }

    event.target.value = value;
  });

  document.addEventListener('click', function (event) {
    if (!event.target.classList.contains('frete-frenet-button')) return;

    const box = event.target.closest('.frete-frenet-produto');
    if (!box) return;

    calculateShipping(box);
  });
})();